/**
 * Mappers for area detail operations
 */

import type {
  AreaDetail,
  LC_GetCompanyAreaByIdOut,
} from '../types';

/**
 * Map area detail from transport to domain model
 */
export function mapAreaDetailFromTransport(
  transport: LC_GetCompanyAreaByIdOut,
): AreaDetail {
  return {
    id: transport.areaId,
    code: transport.areaCode,
    name: transport.areaName,
    parentAreaId: transport.parentAreaId,
    parentAreaName: transport.parentAreaName,
    isEnabled: transport.isEnabled,
    createdDate: transport.createdDate,
    createdBy: transport.createdBy,
    modifiedDate: transport.modifiedDate,
    modifiedBy: transport.modifiedBy,
  };
}
